var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticClass:"caption status-selector",style:({
      backgroundColor: _vm.statusColor,
    }),attrs:{"items":_vm.statusOptions,"item-text":"value","dense":"","hide-details":"","outlined":"","value":_vm.currentStatus,"loading":_vm.updateProcessing},on:{"change":(selected) => _vm.onChange(selected)},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }